import { useState } from "react";
import { Link } from "react-router-dom";
import { Instagram, Mail, MapPin } from "lucide-react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";
import SponsorsWall from "@/components/site/SponsorsWall";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const subscribe = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      await api.post("/newsletter", { email });
      toast.success("You're in the Spider-Society! Watch your inbox.");
      setEmail("");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Try again");
    } finally {
      setLoading(false);
    }
  };

  return (
    <footer data-testid="site-footer" className="relative bg-[#101018] border-t border-white/10 mt-20">
      <SponsorsWall />
      <div className="halftone absolute inset-0 opacity-30 pointer-events-none" />
      <div className="relative max-w-7xl mx-auto px-6 py-16 grid gap-12 md:grid-cols-4">
        <div className="md:col-span-2">
          <div className="font-display text-4xl chromatic mb-3">ENTER THE SPIDER-VERSE</div>
          <p className="text-white/60 max-w-md font-head">
            Denver's premier all-ages multiverse art, music &amp; cosplay experience.
          </p>
          <form onSubmit={subscribe} className="mt-6 flex gap-2 max-w-sm">
            <input
              data-testid="newsletter-input"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="your@email.com"
              className="flex-1 bg-[#08080c] border border-white/15 rounded-full px-4 py-2.5 text-sm outline-none focus:border-[#00f0ff]"
            />
            <button
              data-testid="newsletter-submit"
              disabled={loading}
              className="bg-[#00f0ff] text-black font-head font-bold uppercase text-sm px-5 rounded-full hover:scale-105 transition-transform disabled:opacity-60"
            >
              Join
            </button>
          </form>
        </div>

        <div>
          <div className="font-head uppercase tracking-widest text-sm text-[#ffe600] mb-4">Explore</div>
          <ul className="space-y-2 text-white/70 font-head">
            <li><Link to="/entertainment" className="hover:text-[#00f0ff]">Lineup</Link></li>
            <li><Link to="/tickets" className="hover:text-[#00f0ff]">Tickets</Link></li>
            <li><Link to="/get-involved" className="hover:text-[#00f0ff]">Vendors &amp; Sponsors</Link></li>
            <li><Link to="/sponsor-deck" className="hover:text-[#00f0ff]">Sponsorship Deck</Link></li>
            <li><Link to="/faq" className="hover:text-[#00f0ff]">FAQ &amp; Venue</Link></li>
            <li><Link to="/admin/login" className="hover:text-[#00f0ff]">Admin</Link></li>
          </ul>
        </div>

        <div>
          <div className="font-head uppercase tracking-widest text-sm text-[#ffe600] mb-4">Venue</div>
          <ul className="space-y-3 text-white/70 font-head text-sm">
            <li className="flex gap-2"><MapPin size={16} className="text-[#ff0055] shrink-0 mt-0.5" /> The Truss House at RiNo ArtPark, 3400 Arkins Ct, Denver, CO 80216</li>
            <li className="flex gap-2"><Mail size={16} className="text-[#ff0055] shrink-0 mt-0.5" /> dondrae@eventism.com</li>
            <li className="flex gap-2"><Instagram size={16} className="text-[#ff0055] shrink-0 mt-0.5" /> @spiderverse.denver</li>
          </ul>
        </div>
      </div>
      <div className="relative border-t border-white/10 py-6 text-center text-xs text-white/40 font-mono2">
        © 2026 Eventism · Into the Spider-Verse: Denver · An unofficial fan-made all-ages celebration
      </div>
    </footer>
  );
}
